import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import GroupEntriesLoader from './groupEntriesLoader';
import ListMainWrapper from '../../common/listMainWrapper';
import List from './list';
import CheckboxListItem from '../ldapMappingCheckboxListItem';

@inject('translationsStore', 'groupMapping') @observer
export default class AddLdapGroupMappingListContainer extends Component {

    groupMapping = this.props.groupMapping;

    
    rowRenderer = ({key, index, isScrolling, isVisible, style}) => {
        
        let item = this.props.groupMapping.groupEntriesOptimized[index];
        
        return(
            <CheckboxListItem
                key={item.id}
                dataKey={item.id}
                checked={item.selected}
                imported={item.imported}
                name={item.name}
                group={item.group}
                selcted={item.selectd}
                toggle={this.toggle}
                translations={{mapped: this.props.translationsStore.translate('MAPPED')}}
                style={style}
            />
        )
    }
    
    toggle = (id) => {

        let list = [];

        this.props.groupMapping.groupEntriesOptimized.forEach((item) => {
            
            if (item.id === id) {

                item.selected = !item.selected;

                if (item.selected) {
                    
                    this.props.groupMapping.appnedEntryId({
                        teamId: item.teamId,
                        ldapGroupDn: item.group,
                        ldapGroupDisplayName: item.name
                    });
                }
                else {
                    this.props.groupMapping.removeEntryId(id);
                }
            }

            list.push(item);
        });

        this.props.groupMapping.setGroupEntriesOptimized(list);
    }

    render() {

        return (
            <div>
                {
                    this.props.groupMapping.searchGroupEntriesProgress ?
                        <GroupEntriesLoader />
                            : <ListMainWrapper
                                    scrollsHeight='25vh'
                                    selectableList
                                    items={this.props.groupMapping.groupEntriesOptimized}
                                    translations={{                                   
                                        title1: this.props.translationsStore.translate('GROUP'),
                                        title2: this.props.translationsStore.translate('GROUP_DN'),
                                        noEntries: this.props.translationsStore.translate('NO_GROUP_ENTRIES'),
                                        searchIconToSearchUsers: this.props.translationsStore.translate('SEARCH_ICON_TO_SEARCH_THE_LDAP_GROUPS')
                                    }}
                                    rowHeight={40}
                                    rowRenderer={this.rowRenderer}
                                />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teams/addLdapGroupMappingList/index.jsx